import StoreModule from '@/services/store/modules/store-module';

class HomeStore extends StoreModule {
  constructor(properties = {}) {
    super(properties);

    const endpoint = 'home';

    const api = this.api;
    const MUTATION = this.MUTATION;
    const ACTION = this.ACTION;

    this.state = {
      content: null,
    };

    this.getters = {
      content: state => state.content,
    };

    this.actions = {
      /**
       *
       * @param commit
       * @returns {Promise<unknown>}
       */
      [ACTION.GET_HOME_CONTENT]({ commit }) {
        return new Promise((resolve, reject) => {
          api.get(`${endpoint}`)
            .then(response => callbacks.getHomeContent(commit, resolve, reject, response))
            .catch(error => reject(error));
        });
      },
    };

    const callbacks = {
      /**
       *
       * @param commit
       * @param resolve
       * @param reject
       * @param response
       * @returns {*}
       */
      getHomeContent: (commit, resolve, reject, response) => {
        if (response.status === 200 && response.data) {
          const content = response.data;
          commit(MUTATION.SET_HOME_CONTENT, { content });
          return resolve(content);
        }
        commit(MUTATION.RESET_HOME_CONTENT);
        return reject(response.meta);
      },
    };
    this.callbacks = callbacks;

    this.mutations = {
      /**
       *
       * @param state
       * @param content
       */
      [MUTATION.SET_HOME_CONTENT](state, { content }) {
        state.content = content;
      },
    };
  }
}

const home = new HomeStore();

export default home;
